module.exports = __webpack_public_path__ + "28d65526523af8fdea2861cb02c2cb68.svg";